import {
  INSUFF_DATA_FAILED,
  INSUFF_DATA_LOADING,
  INSUFF_DATA_SUCCESS,
  INSUFF_DATA_SAVE_FAILED,
  INSUFF_DATA_SAVE_LOADING,
  INSUFF_DATA_SAVE_SUCCESS,
  INSUFF_UPLOAD_FILE_MULTIPART_FAILED,
  INSUFF_UPLOAD_FILE_MULTIPART_LOADING,
  INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS,
  INSUFF_DELETE_FILES_FAILED,
  INSUFF_DELETE_FILES_LOADING,
  INSUFF_DELETE_FILES_SUCCESS,
  REMOVE_SINGLE_FILE_FAILED,
  REMOVE_SINGLE_FILE_LOADING,
  REMOVE_SINGLE_FILE_SUCCESS,
} from "../Constants/InsuffConstants";

const addFiles = (data, state) => {
  console.log('filessssss',state)
  let payloadData = {}
  payloadData.code = data?.code
  payloadData.status = data?.status
  payloadData.files = state?.InsuffUploadFilesData?.files?.length 
  ? [...state?.InsuffUploadFilesData?.files,...data?.files] 
  : [...data?.files]
  return payloadData;

}

export const InsuffReducer = (state = { InsuffData: {} }, action) => {
  switch (action.type) {
    case INSUFF_DATA_LOADING:
      return { loading: true, InsuffData: {} };
    case INSUFF_DATA_SUCCESS:
      return { loading: false, InsuffData: action.payload };
    case INSUFF_DATA_FAILED:
      return { loading: false, error: action.InsuffData };
    case INSUFF_DATA_SAVE_LOADING:
      return { loading: true, InsuffData: { ...state.InsuffData } };
    case INSUFF_DATA_SAVE_SUCCESS:
      return { loading: false, InsuffData: { ...state.InsuffData } };
    case INSUFF_DATA_SAVE_FAILED:
      return { loading: false, InsuffData: { ...state.InsuffData } };
    default:
      return state;
  }
};

// export const InsuffSaveReducer = (
//   state = { insuffSaveData: [] },
//   action
// ) => {
//   switch (action.type) {
//     case INSUFF_DATA_SAVE_LOADING:
//       return { loading: true, insuffSaveData: [] };
//     case INSUFF_DATA_SAVE_SUCCESS:
//       return { loading: false, insuffSaveData: action.payload };
//     case INSUFF_DATA_SAVE_FAILED:
//       return { loading: false, error: action.insuffSaveData };
//     default:
//       return state;
//   }
// };

export const InsuffUploadFilesReducer = (
  state = { InsuffUploadFilesData: {} },
  action
) => {
  switch (action.type) {
    case INSUFF_UPLOAD_FILE_MULTIPART_LOADING:
      return { loading: true, InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
      } };
    case INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS:
      return {
        loading: false,
        InsuffUploadFilesData: {
          ...addFiles(action.payload, state)
        },
      };
    case INSUFF_UPLOAD_FILE_MULTIPART_FAILED:
      return { loading: false, error: action.InsuffUploadFilesData };
    case REMOVE_SINGLE_FILE_LOADING:
      return {
        loading: true,
        InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
        },
      };
    case REMOVE_SINGLE_FILE_SUCCESS:
      // const {status, code} = state?.InsuffUploadFilesData
      return {
        loading: false,
        InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
          files: [...state.InsuffUploadFilesData.files.filter(file => file.name !== action.payload.fileName )],
        },
      };
    case REMOVE_SINGLE_FILE_FAILED:
      return {
        loading: false,
        InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
        },
      };
    case INSUFF_DELETE_FILES_LOADING:
      return {
        loading: true,
        InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
        },
      }
    case INSUFF_DELETE_FILES_SUCCESS: 
    return {
        loading: false,
        InsuffUploadFilesData : {}
    }
    case INSUFF_DELETE_FILES_FAILED:
      return {
        loading: false,
        InsuffUploadFilesData: {
          ...state.InsuffUploadFilesData,
          ...action.payload,
        },
      }
    default:
      return state;
  }
};
